import React, { FC, Fragment } from 'react';
import { Box, Text } from '@bechtel/gds';
import { WeldSubHeaderProps } from './types';
import { EllipseStyled } from './styled';

export const WeldSubHeader: FC<WeldSubHeaderProps> = ({ tag, pipeMaterial, pipeDiameter }) => {
  return (
    <Fragment>
      <Text size="500" family="graphik" color="grey.1000" data-testid="weld-tag-container">
        {tag}
      </Text>
      <Box mt={{ sm: '300' }}>
        {pipeMaterial && (
          <Box
            data-testid="weld-pipeMaterial"
            mr={{ sm: '400' }}
            flexDirection={{ sm: 'row' }}
            alignItems={{ sm: 'center' }}
          >
            <Text size="300" color="grey.700">
              {pipeMaterial}
            </Text>
          </Box>
        )}
        {!!pipeDiameter && pipeMaterial && <EllipseStyled data-testid="weld-ellipsis" />}
        {!!pipeDiameter && (
          <Text data-testid="weld-pipeDiameter" size="300" color="grey.700">
            {`${pipeDiameter} ${`''`}`}
          </Text>
        )}
      </Box>
    </Fragment>
  );
};
